export const queryKeys = {
  featureFlags: ['feature-flags'] as const,
  dashboardMetrics: ['dashboard-metrics'] as const,
  dashboardUsers: ['dashboard-users'] as const,
  dashboardSocieties: ['dashboard-societies'] as const,
  dashboardInterventions: ['dashboard-interventions'] as const,
  dashboardReports: ['dashboard-reports'] as const,
  dashboardNotifications: ['dashboard-notifications'] as const,
  dashboardSectorMap: ['dashboard-sector-map'] as const,
  dashboardPendingValidations: ['dashboard-pending-validations'] as const,
  dashboardPendingPhoneValidations: [
    'dashboard-pending-phone-validations',
  ] as const,
  globalSettings: ['global-settings'] as const,
  userDetail: (id: string) => ['user-detail', id] as const,
  agentDetail: (id: string) => ['agent-detail', id] as const,
  societyDetail: (id: string) => ['society-detail', id] as const,
  documents: (entityType: string, entityId: string) =>
    ['documents', entityType, entityId] as const,
  search: (query: string, entityType?: string) =>
    ['search', query, entityType] as const,
  dashboardNotRegisteredAgents: ['dashboard-not-registered-agents'] as const,
  dashboardMunicipalities: ['dashboard-municipalities'] as const,
  municipalityDetail: (id: string) => ['municipality-detail', id] as const,
  geoRegions: (search?: string) => ['geo-regions', search] as const,
  geoRegionsGeoJSON: (ids: string[]) => ['geo-regions-geojson', ...ids.sort()] as const,
  contentReports: (filters?: Record<string, unknown>) => ['content-reports', filters ?? {}] as const,
  contentReportsPendingCount: ['content-reports-pending-count'] as const,
  brands: (filters?: Record<string, unknown>) => ['brands', filters ?? {}] as const,
  securityDomains: ['security-domains'] as const,
  societyDocumentStatus: (id: string) => ['society-document-status', id] as const,
  feed: (filters?: Record<string, unknown>) => ['feed', filters ?? {}] as const,
  interventionDetail: (id: string) => ['intervention-detail', id] as const,
  interventionEventLog: (id: string) => ['intervention-event-log', id] as const,
  interventionPhotos: (id: string) => ['intervention-photos', id] as const,
  securityRequestsAll: ['security-requests'] as const,
  securityRequests: (filters?: Record<string, unknown>) => ['security-requests', filters ?? {}] as const,
  securityRequestCounts: ['security-request-counts'] as const,
  securityRequestDetail: (id: string) => ['security-request-detail', id] as const,
  securityCatalog: ['security-catalog'] as const,
} as const;
